import * as React from "react"
import { graphql, useStaticQuery } from "gatsby"
import { storyblokEditable } from "gatsby-source-storyblok"
import { Href } from "../utils/helper"
import TourTags from "./tourTags"
import TourPrice from "./tourPrice"
import { Lang, LangEnum, Trans } from "../utils/lang"

const MegaMenuTour = ({ blok, full_slug }) => {
  // console.log(blok);
  const bgImage = blok.bannerBgImage?.filename ? 
    `url(${blok.bannerBgImage?.filename}/m/640x400)` : 
    'url("https://img.freepik.com/free-photo/cherry-blossoms-spring-chureito-pagoda-fuji-mountain-japan_335224-213.jpg")';

  return (
    <a href={`/${full_slug}`} {...storyblokEditable(blok)} 
      className="max-w-[420px] min-h-[200px] aspect-[1.5/1] lg:aspect-[2/1] mb-5 cursor-pointer rounded-md bg-cover bg-center hover:scale-105 transition hover:shadow-md"
      style={{ 'backgroundImage': `${bgImage}` }}>
        
      <div className="flex flex-col h-full rounded-md bg-black bg-opacity-20 text-white text-left p-4">
        <div className="text-sm mt-4 mb-2">{blok.tourSubHeading}</div>
        <div className="font-serif font-bold mb-4">{blok.tourTitle}</div>
        <TourTags blok={blok} />
        <div className="font-bold mt-5"><TourPrice currency={blok.currency} price={blok.price} /></div>

      </div>
      
    </a>
  )
}

const MegaMenuTags = ({ blok }) => {
  return (
    blok.label?.value &&
    blok.label?.value
    .map((tag, i) => (
    <a key={i} href={Href(blok.link) + `?label=${tag}`} className="cursor-pointer text-blue-700 border-b-2 border-blue-700 mr-4">
      {tag}
    </a>))
  )
}

const MegaMenuAccomodation = ({ accommodations }) => {
  return (
    accommodations.edges.map((e, i) => (
      <a key={i} href={`/${e.node.full_slug}`} className="cursor-pointer hover:text-gray-500 block">
        {e.node.name}
      </a>))
  )
}

const MegaMenuCategory = ({ categories }) => {
  const lang = Lang()
  return (
    categories.edges
    .filter(({ node }) => {
      if (lang === LangEnum.JA && node.full_slug?.startsWith('ja/')) return true
      if (lang === LangEnum.EN && !node.full_slug?.startsWith('ja/')) return true
      return false
    })
    .slice(0, 7)
    .map((e, i) => (
    <a key={i} href={`/${e.node.full_slug}`} className="cursor-pointer hover:text-gray-500 block">
      {e.node.name}
    </a>))
  )
}

const MegaMenuBlog = ({ blogs }) => {
  return (
    blogs.edges
    .map((e, i) => (
    <a key={i} href={`/${e.node.full_slug}`} className="cursor-pointer hover:text-gray-500 block truncate max-w-[300px]">
      {e.node.name}
    </a>))
  )
}


const MegaMenu = ({ blok, linkOnly }) => {
  const { accommodations, categories, blogs } = useStaticQuery(graphql`
  query {

    accommodations: allStoryblokEntry(filter: {field_component: {eq: "accommodationItem"}, full_slug: {regex: "/^accommodation/"}}) {
      edges {
        node {
          name
          full_slug
          field_component
        }
      }
    }

    categories: allStoryblokEntry(filter: {field_component: {eq: "category"}}) {
      edges {
        node {
          name
          full_slug
        }
      }
    }

    blogs: allStoryblokEntry(
      filter: {field_component: {eq: "blogArticle"}, full_slug: {regex: "/^blog/"}}
      sort: {published_at: DESC}
      limit: 5
    ) {
      edges {
        node {
          uuid
          name
          full_slug
          slug
          published_at(formatString: "MM/DD/YYYY")
        }
      }
    }
  } 
  `)
  // console.log(blok, tours, accommodations)

  return (
    <div className={`${linkOnly ? '' : 'px-5 xl:px-8'}`}>
      <a href={Href(blok.link)} {...storyblokEditable(blok)} className="cursor-pointer text-base font-medium hover:text-gray-500 mt-6 mb-2 block">
        {blok.name}
      </a>
      { blok.component === "megaMenuTags" && <MegaMenuTags blok={blok} /> }
      <div className="flex flex-col">
        { !linkOnly && blok.component === "megaMenuTour" && <MegaMenuTour blok={blok.tour.content} full_slug={blok.tour.full_slug} /> }
        { blok.subMenu && blok.subMenu.length > 0 &&
          blok.subMenu.map((menu, i) =>
            <a key={i} href={Href(menu.link)} {...storyblokEditable(menu)} className="cursor-pointer truncate max-w-[300px] hover:text-gray-500 block">
              {menu.name}
            </a>)
        }
        { blok.menuType === "accommodation" && <MegaMenuAccomodation accommodations={accommodations} /> }
        { blok.menuType === "category" && <MegaMenuCategory categories={categories} /> }
        { blok.menuType === "blog" && <MegaMenuBlog blogs={blogs} /> }

        { blok.viewAllLink?.cached_url &&
          <>
            <p>............</p>
            <a href={Href(blok.viewAllLink)} {...storyblokEditable(blok)} className="cursor-pointer hover:text-gray-500 block">
            {Trans('viewAll')}
            </a>
          </>
        }
      </div>
    </div>
  )
}

export default MegaMenu
